const HIGHLIGHT_STATE_PREFIX = "smbf.attendeeHighlights";

function storageKey(viewerObjectId: string, eventId: string): string {
  return `${HIGHLIGHT_STATE_PREFIX}.${viewerObjectId}.${eventId}`;
}

function readKeys(viewerObjectId: string, eventId: string): string[] {
  if (!viewerObjectId || !eventId) return [];
  try {
    const raw = localStorage.getItem(storageKey(viewerObjectId, eventId));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.map((id) => String(id ?? "").trim()).filter(Boolean);
  } catch {
    return [];
  }
}

function writeKeys(
  viewerObjectId: string,
  eventId: string,
  keys: string[]
): void {
  if (!viewerObjectId || !eventId) return;
  try {
    localStorage.setItem(
      storageKey(viewerObjectId, eventId),
      JSON.stringify(Array.from(new Set(keys)))
    );
  } catch {
    // ignore quota / private mode
  }
}

/** Selected (highlighted) attendee keys for this viewer + event. */
export function loadHighlightedAttendeeKeys(
  viewerObjectId: string,
  eventId: string
): Set<string> {
  return new Set(readKeys(viewerObjectId, eventId));
}

export function toggleHighlightedAttendeeKey(
  viewerObjectId: string,
  eventId: string,
  key: string
): Set<string> {
  const selectKey = (key || "").trim();
  const existing = readKeys(viewerObjectId, eventId);
  if (!selectKey) return new Set(existing);

  const idx = existing.indexOf(selectKey);
  if (idx >= 0) existing.splice(idx, 1);
  else existing.push(selectKey);

  writeKeys(viewerObjectId, eventId, existing);
  return new Set(existing);
}
